import Yup from '../shared/libs/yup/yup';
import i18n from '../i18n';

export const initWebsiteSchema = Yup.object().shape({
    name: Yup.string()
        .required(i18n.t('onBoarding:validation.name.required'))
        .max(50, i18n.t('onBoarding:validation.name.max', { max: 50 })),
    themeId: Yup.number().required(i18n.t('onBoarding:validation.theme.required')),
});
